import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGears } from '@fortawesome/free-solid-svg-icons';
import { DialogSelectWithMoreConfig } from './DialogInputs';
import FunctionParamsDialog from './Dialogs/Configuration/FunctionParamsDialog';

export function FunctionSelect({ controlId, title, name, functions, onChangeFunction, onChangeParams, value, error }) {

    const getFunctionNameOnly = (functionNameWithParams) => {
        if (functionNameWithParams === undefined || functionNameWithParams == null)
            return functionNameWithParams;

        let braceIndex = functionNameWithParams.indexOf("(");
        if (braceIndex === -1)
            return functionNameWithParams;

        return functionNameWithParams.substr(0, braceIndex);
    };

    const getMatchingFunction = (functions, findFunctionName) => {
        if (functions === undefined)
            return null;

        let findFunctionNameWithoutParams = getFunctionNameOnly(findFunctionName);

        for (let idx = 0; idx < functions.length; idx++) {
            let func = functions[idx];
            let funcNameWithoutParams = getFunctionNameOnly(func.name);

            if (findFunctionNameWithoutParams === funcNameWithoutParams) {
                return func;
            }
        }

        return null;
    };

    const getFunctionParameterValues = (functionNameWithParams) => {
        if (functionNameWithParams === undefined || functionNameWithParams == null)
            return [];

        let braceIndex = functionNameWithParams.indexOf("(");
        if (braceIndex === -1)
            return [];

        let paramsPart = functionNameWithParams.substring(braceIndex + 1, functionNameWithParams.length - 1);

        return paramsPart.split(",");
    };

    const FunctionParamsCell = ({ func, fieldName }) => {
        const [showFunctionParams, setShowFunctionParams] = useState(false);
        let initialParameterValues = getFunctionParameterValues(value);
        const [parameters, setParameters] = useState(initialParameterValues);

        const SaveParams = (params) => {
            // Put the parameters back into a full function name string + args in the dialog data

            // Common dialog save expects a promise.. We can 'reject' here with field errors if we want
            let promise = new Promise((resolve, reject) => {
                // NB, params is an object if its been modified, it it hasn't (user just pressed ok) then its an array..
                let functionNameWithParams = func.name + "(";

                for (var paramIdx = 0; paramIdx < func.parameters.length; paramIdx++) {
                    if (paramIdx > 0)
                        functionNameWithParams += ",";

                    const defaultValue = func.parameters[paramIdx].type === 'Boolean' ? false : undefined
                    functionNameWithParams += params[paramIdx] ?? defaultValue;
                }
                functionNameWithParams += ")";

                // Anything to validate in here?

                if (onChangeParams !== undefined) {
                    onChangeParams(fieldName, functionNameWithParams)
                }

                let fieldDOM = document.querySelector("[name=" + fieldName + "]");
                fieldDOM.setCustomValidity("");

                resolve(functionNameWithParams);
            });

            return promise;
        };

        return (
            <Button variant="outline-secondary">
                <FontAwesomeIcon className="link" icon={faGears} onClick={() => setShowFunctionParams(true)} />
                <FunctionParamsDialog fieldName={fieldName} func={func} showDialog={showFunctionParams} parameters={parameters} setParameters={setParameters} closeDialog={() => setShowFunctionParams(false)} save={SaveParams} />
            </Button>
        );
    }

    const onChangeFunctionSelect = (functions) => (e) => {
        let field = e.currentTarget.name;

        let value = e.currentTarget.value;
        let matchingFunc = getMatchingFunction(functions, value);
        let params = getFunctionParameterValues(value);

        e.currentTarget.setCustomValidity("");

        // Validate selection
        if (matchingFunc != null && matchingFunc.parameters.length !== params.length) {
            e.currentTarget.setCustomValidity("Invalid arguments supplied");
        }

        if (onChangeFunction !== undefined) {
            onChangeFunction(field, value, e.currentTarget.validity.valid, e.currentTarget.validationMessage)
        }
    };

    
    let matchingFunc = getMatchingFunction(functions, value);
    let selectedFnhasArgs = (matchingFunc != null && matchingFunc.parameters.length > 0);

    let functionConfig = selectedFnhasArgs ? <FunctionParamsCell func={matchingFunc} fieldName={name}></FunctionParamsCell> : null;

    return (
        <DialogSelectWithMoreConfig controlId={controlId} title={title} name={name} additionalConfig={functionConfig} value={getFunctionNameOnly(value)} error={error} onChange={onChangeFunctionSelect(functions)}>
            <option value="" key={0}>Please Select...</option>
            {functions.map((func, index) => <option value={func.name} key={index}>{(matchingFunc !== null) && (matchingFunc.name === func.name) ? value : func.name}</option>)}
        </DialogSelectWithMoreConfig>
    );
}